import { createFetch } from '@vueuse/core';
import { useStore } from './stores/main';
import { getBackendLanguageCode } from './helpers';
import { debugLog } from '@/utils/logger';

export const useBackendFetch = createFetch({
  baseUrl: import.meta.env.APP_BACKEND_API_ENDPOINT,
  options: {
    // Abort requests that hang on bad connections instead of spinning forever.
    timeout: 20000,
    async beforeFetch({ options, url }) {
      const store = useStore();

      // TEMPORARILY DISABLED - Session validation
      // // Check if session is expired before making API calls
      // if (store.loggedIn && store.isSessionExpired()) {
      //   store.logout();
      //   throw new Error('Session expired');
      // }

      // Get current language from localStorage (same way LanguageSwitcher stores it)
      const currentLocale = localStorage.getItem('userLocale') || 'sv';
      const currentLang = getBackendLanguageCode(currentLocale);

      // Add language parameter to URL
      const urlObj = new URL(url, import.meta.env.APP_BACKEND_API_ENDPOINT);
      urlObj.searchParams.set('lang', currentLang);

      // Debug: Log the API request with language parameter (temporarily disabled)

      // Add authorization header if token exists
      if (store.token !== null && store.token !== '') {
        if (options.headers === undefined) {
          options.headers = {};
        }

        (options.headers as Record<string, string>)['Authorization'] =
          `Bearer ${store.token}`;
      }

      return { 
        options,
        url: urlObj.toString()
      };
    },
    async afterFetch({ response, data }) {
      const store = useStore();
      
      // Update activity on successful API calls
      if (store.loggedIn && response.ok) {
        store.updateLastActivity();
      }
      
      return { response, data };
    },
    async onFetchError({ error, response, data }) {
      const store = useStore();
      
      // Handle 401 errors by logging out
      if (response?.status === 401 && store.loggedIn) {
        debugLog('401 error - session invalid, logging out');
        store.logout();
      }

      if (response?.status === 409 && data?.onboarding && store.loggedIn) {
        store.onboarding = data.onboarding;
        if (window.location.pathname !== '/complete-registration') {
          window.location.replace('/complete-registration');
        }
      }
      
      return { error, response, data };
    },
  },
  fetchOptions: {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
    },
  },
});
